import { Tabs, Tab } from 'react-bootstrap'
import './profile.css'
import Overview from './Overview'
import Assignments from './Assignments'
import Settings from './Settings'
import Pathways from './Pathways'
import { useContext } from 'react'
import { ProfileContext } from 'pages/Profile'

export default function Menu() {

  const { profile } = useContext(ProfileContext)

  // console.log(`Profile Menu:`, profile);

  return (
    <Tabs
      defaultActiveKey="overview"
      className='mb-3'
      data-bs-theme="dark"
    >
      <Tab eventKey="overview" title="Overview" >
        <Overview />
      </Tab>
      <Tab eventKey="assignments" title="Assignments" >
        <Assignments />
      </Tab>
      {(profile.acl === 'Officer' || profile.acl === 'Member') && (
        <Tab eventKey="pathways" title="Pathways" >
          <Pathways />
        </Tab>
      )}

      <Tab eventKey="settings" title="Settings" >
        <Settings />
      </Tab>
    </Tabs>
  )

}